<template>
    <div class="alarm-configuration-container" style="margin-right: 20px">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点选择'">
            <div class="tree-container">
                <me-tree
                    ref="myTree"
                    :defaultProps="defaultProps"
                    :treeData="treeList"
                    :nodeKey="'point_id'"
                    :isSingle="true"
                    :showCheckbox="true"
                    :isCheckClick="true"
                    :title="'采集点选择'"
                    :checkStrictly="true"
                    :treeLoading="treeLoading"
                    :defaultExpandedKeys="expandedKeys"
                    :treeToolBar="false"
                    @handleCheckBoxClick="handleTreeNodeClick"
                ></me-tree>
            </div>
        </me-collapes>
        <div class="form-wrap">
            <el-scrollbar style="height: 100%">
                <el-form
                    label-width="150px"
                    ref="alarmRef"
                    :model="alarmConf"
                    class="leader-style-form"
                >
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >电流(A相)</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_Ia"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >A</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_Ia"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >A</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >电流(B相)</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_Ib"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >A</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_Ib"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >A</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >电流(C相)</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_Ic"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >A</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_Ic"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >A</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >电压(A相)</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_Va"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >V</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_Va"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >V</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >电压(B相)</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_Vb"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >V</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_Vb"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >V</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >电压(C相)</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_Vc"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >V</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_Vc"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >V</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >功率(A相)</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_Pa"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >kW</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_Pa"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >kW</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >功率(B相)</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_Pb"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >kW</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_Pb"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >kW</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >功率(C相)</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_Pc"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >kW</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_Pc"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >kW</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="leader-card">
                        <div slot="header" class="clearfix">
                            <span style="float: left;font-size:16px"
                                >总功率</span
                            >
                        </div>
                        <el-row :gutter="24">
                            <el-col :sm="12" :md="12">
                                <el-form-item label="高:">
                                    <el-input
                                        v-model="alarmConf.hight_warn_line_P"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >kW</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12">
                                <el-form-item label="低:">
                                    <el-input
                                        v-model="alarmConf.low_warn_line_P"
                                        oninput="value=value.replace(/[^\d]/g,'')"
                                        maxlength="8"
                                    >
                                        <i class="el_input_i" slot="suffix"
                                            >kW</i
                                        >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-row style="text-align: center">
                        <el-button
                            class="leader-common-button"
                            @click="saveMethod()"
                            >保&nbsp;&nbsp;&nbsp;&nbsp;存</el-button
                        >
                    </el-row>
                </el-form>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import MeTree from "@/comon/components/tree.vue";
import { getAlarmInfo, saveAlarmInfo } from "@/http/hr.js";
import Collapes from "@/comon/components/collapse-block.vue";
import * as api from "@/http/api.js";

export default {
    components: { MeTree, "me-collapes": Collapes },
    data() {
        return {
            expandedKeys: [], //默认展开节点
            warn_type: {
                VA: 10, // A相电压
                VB: 11, // B相电压
                VC: 12, // C相电压
                IA: 20, // A相电流
                IB: 21, // B相电流
                IC: 22, // C相电流
                PA: 30, // A相功率
                PB: 31, // B相功率
                PC: 32, // C相功率
                P: 33 // 总功率
            },
            point_id: "",
            alarmConf: {},
            treeList: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            }
        };
    },
    created() {
        this.getPointTree();
    },
    methods: {
        getPointTree() {
            this.treeLoading = true;
            api.getPointList().then(res => {
                if (res && res.error_code === "0") {
                    this.treeList = res.bus_json;
                    this.tickMenuIdFilter().filter(this.treeList);
                    let firstPoint = this.tickMenuIdFilter().getFirst(
                        this.treeList
                    );
                    this.point_id = firstPoint.point_id;
                    this.expandedKeys = [firstPoint.point_id];
                    this.$refs.myTree.handleCheckBoxClick(firstPoint);
                    // this.point_id = res.bus_json[0].point_id;
                    // this.$refs.myTree.handleCheckBoxClick(res.bus_json[0]);
                    this.getAlarmInfo(this.point_id);
                }
                this.treeLoading = false;
            });
        },

        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function(obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.state === "1") {
                    //虚点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else if (obj.state == "0") {
                    //实采集点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function(arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return resultArr;
                },
                // 获取第一个实采集点
                getFirst: function(arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return firstPoint;
                }
            };
        },
        handleTreeNodeClick(select) {
            if (select.state == "0") {
                // 实采集点
                this.point_id = select.point_id;
                this.getAlarmInfo(this.point_id);
                return;
            }
        },
        getAlarmInfo(point_id) {
            getAlarmInfo({ point_id: point_id }).then(res => {
                if (res && res.error_code === "0") {
                    const { bus_json } = res;
                    this.alarmConf = bus_json;
                    for (let val in this.alarmConf) {
                        if (this.alarmConf[val] === null) {
                            this.alarmConf[val] = "";
                        }
                    }
                }
            });
        },
        saveMethod() {
            const ia = `${this.point_id}#${this.warn_type.IA}#${this.alarmConf.hight_warn_line_Ia}#${this.alarmConf.low_warn_line_Ia}`;
            const ib = `${this.point_id}#${this.warn_type.IB}#${this.alarmConf.hight_warn_line_Ib}#${this.alarmConf.low_warn_line_Ib}`;
            const ic = `${this.point_id}#${this.warn_type.IC}#${this.alarmConf.hight_warn_line_Ic}#${this.alarmConf.low_warn_line_Ic}`;
            const va = `${this.point_id}#${this.warn_type.VA}#${this.alarmConf.hight_warn_line_Va}#${this.alarmConf.low_warn_line_Va}`;
            const vb = `${this.point_id}#${this.warn_type.VB}#${this.alarmConf.hight_warn_line_Vb}#${this.alarmConf.low_warn_line_Vb}`;
            const vc = `${this.point_id}#${this.warn_type.VC}#${this.alarmConf.hight_warn_line_Vc}#${this.alarmConf.low_warn_line_Vc}`;
            const pa = `${this.point_id}#${this.warn_type.PA}#${this.alarmConf.hight_warn_line_Pa}#${this.alarmConf.low_warn_line_Pa}`;
            const pb = `${this.point_id}#${this.warn_type.PB}#${this.alarmConf.hight_warn_line_Pb}#${this.alarmConf.low_warn_line_Pb}`;
            const pc = `${this.point_id}#${this.warn_type.PC}#${this.alarmConf.hight_warn_line_Pc}#${this.alarmConf.low_warn_line_Pc}`;
            const p = `${this.point_id}#${this.warn_type.P}#${this.alarmConf.hight_warn_line_P}#${this.alarmConf.low_warn_line_P}`;

            const datas = [ia, ib, ic, va, vb, vc, pa, pb, pc, p];
            const data_json = datas.join(";");
            saveAlarmInfo({ json_str: data_json }).then(res => {
                if (res && res.error_code === "0") {
                    this.$notify({
                        title: "成功",
                        message: res.error_msg,
                        type: "success"
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
// .el_input_i {
//     color: #333;
//     margin-right: 10px;
// }
// .alarm_card {
//     margin-top: 20px;
// }
// .clearfix:after {
//     display: table;
//     content: "";
// }

// .clearfix:after {
//     clear: both;
// }
// .el_button {
//     margin: 20px 0;
// }
// .el-scrollbar__view {
//     height: 1260px;
//     overflow: scroll;
// }
.alarm-configuration-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: px2Rem(20px);
    box-sizing: border-box;
    .tree-container {
        width: 280px;
        // border-right: 1px solid #b1c7dd;
        box-sizing: border-box;
        overflow-x: hidden;
    }
    .form-wrap {
        flex: 1;
        margin-left: 20px;
        height: 100%;
        // overflow-y: auto;
    }
}
</style>
